module.exports = __webpack_public_path__ + "static/media/m_eyeshape_monolid_hazel.2aa8a122.png";